import { USERDETAILS } from "../actions/actions";

let initialState={
    
    fname: "",
    email: "",
    mobile: null,
    username: "",
    password: "",
    bookedTrips: []

}

const userdetails=(state=initialState,action)=>{
    console.log("function running",action)
    switch(action.type){
        case USERDETAILS:return{
        ...state,
        ...action.payload
        }

        default:return state
    }
}

export default userdetails;